import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FeatureDetailTable from './featureDetailTable';
import FeatureDependency from './featureDependency';
import FeatureEdit from '../featureMaintenance/featureEdit';
import { getDisplayData } from 'services/featureService';
import SelectByIdModal from 'components/selectByIdModal';
import { mapInwardDependenciesToDisplayData, mapOutwardDependenciesToDisplayData } from 'services/featureService';
import {
    onEditFeature,
    onFeatureSelect,
    onFeatureInwardDependencyUpdate,
    onFeatureOutwardDependencyUpdate,
    showFeatureLoader,
    onFetchSelectFeatureInwardDependencies,
    onFetchSelectFeatureOutwardDependencies,
} from 'actions/feature';
// import { TIGHT_FIT_PARAM } from 'constants/System';

const FeatureDetail = () => {
    // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const featureList = useSelector(state => state.features.featureList);
    const selectedFeature = useSelector(state => state.features.selectedFeature);
    const dependencyList = useSelector(state => state.features.dependencyList);
    

    const mainIcon = (issueType) => {
        if (issueType && issueType.toLowerCase() === 'high') {
            return 'dashboard';
        }
        if (issueType && issueType.toLowerCase() === 'medium') {
            return 'compact';
        }
        if (issueType && issueType.toLowerCase() === 'low') {
            return 'module';
        }
        return 'stream';
    };

    

    if (selectedFeature) {
        // const fields = { ...selectedFeature?.fields };
        const displayData = getDisplayData(selectedFeature);
        const inwardDependencies = mapInwardDependenciesToDisplayData(featureList, selectedFeature) || null;
        const outwardDependencies = mapOutwardDependenciesToDisplayData(featureList, selectedFeature) || null;
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-6 col-12">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h2 className="card-heading">{displayData?.name}</h2>
                                </div>
                                <div>
                                    <SelectByIdModal
                                        modalTitle={<IntlMessages id="label.inwardDependencies" />}
                                        onUpdateHandler={onFeatureInwardDependencyUpdate}
                                        onSelectRowHandler={onFeatureSelect}
                                        onClickButtonHandler={onFetchSelectFeatureInwardDependencies}
                                        selectLoader={showFeatureLoader}
                                        data={dependencyList}
                                        width={width}
                                        actionButtonTextId={<IntlMessages id="label.inwardDependencies" />}
                                    />
                                    <SelectByIdModal
                                        modalTitle={<IntlMessages id="label.outwardDependencies" />}
                                        onUpdateHandler={onFeatureOutwardDependencyUpdate}
                                        onSelectRowHandler={onFeatureSelect}
                                        onClickButtonHandler={onFetchSelectFeatureOutwardDependencies}
                                        selectLoader={showFeatureLoader}
                                        data={dependencyList}
                                        width
                                        actionButtonTextId={<IntlMessages id="label.outwardDependencies" />}
                                    />
                                    <Button size="sm" color="primary" onClick={() => dispatch(onEditFeature())}>
                                        <i className="zmdi zmdi-edit zmdi-hc-fw" />
                                        <span>{<IntlMessages id="label.edit" />}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className="jr-card-body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="temp-section mb-4 mb-sm-0 text-center text-sm-left">
                                            <p>
                                                {/* <div className={`btn btn-sm text-uppercase btn-rounded ${style}`}>{order} Order</div> */}
                                                <i className={`detail-icon text-blue-grey zmdi zmdi-view-${mainIcon(displayData?.priority)} zmdi-hc-fw`} />
                                            </p>
                                            {displayData?.priority ?
                                                <h2 className="temp-point">{displayData?.priority}</h2>
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-9 text-center text-sm-left">
                                        <FeatureDetailTable displayData={displayData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <FeatureEdit />
                    </div>

                    <div className="col-md-3">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <FeatureDependency dependencies={inwardDependencies} title={<IntlMessages id="feature.inwardDependencies" />} />
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <FeatureDependency dependencies={outwardDependencies} title={<IntlMessages id="feature.outwardDependencies" />} />
                        </div>
                    </div>

                </div>
            </div>
        );
    } else {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="jr-card jr-card-full-height">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h3 className="card-heading">Please select an issue to display details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default FeatureDetail;


// WEBPACK FOOTER //
// ./components/Agile/feature/featureDetail/index.js